import { mergeWith as objectMerge, isObjectLike } from 'lodash';
import goTo from 'vuetify/lib/services/goto';

export const moveElementInArray = (array, indexElement, offset) => {
  const element = array[indexElement];
  array.splice(indexElement, 1);
  array.splice(indexElement + offset, 0, element);
};

/**
 * ex: (1, 'номинаци', ['я', 'и', 'й']) -> 'номинация'
 * @param {String} word_base - base of word without ending
 * @param {Number} count - count of elements
 * @param {Array[String]} ending_variants - endings for base word
 * @returns {String} - base word with current ending
 */
export const wordsDeclensions = (word_base, count = 1, ending_variants = ['я', 'и', 'й']) => {
  let ending;
  const [end1, end2, end3] = ending_variants;
  if (count % 10 === 1 && count % 100 !== 11) {
    ending = end1;
  } else if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
    ending = end2;
  } else {
    ending = end3;
  }
  return `${word_base}${ending}`;
};

export const deepObjectMerge = (...objects) => {
  const base = {};
  const currentObjects = [...objects].filter((obj) => typeof obj === 'object');

  const mergeCustomerFn = (objectValue, sourceValue) => {
    if (Array.isArray(objectValue)) {
      return objectValue.concat(sourceValue);
    }
    return undefined;
  };

  return objectMerge(base, ...currentObjects, mergeCustomerFn);
};

export const checkObjectParams = (object, params = [], nullValue = null) => {
  params.forEach((param) => {
    if (object[param] === undefined) {
      object[param] = nullValue;
    }
  });
};

export const scrollTo = (target, offset = 50, options = { container: undefined }) => goTo(
  target,
  { duration: 500, offset },
).then(() => goTo(target, { duration: 200, offset, ...options }));

export const uniformDistribution = (array, requiredLength) => {
  if (array.length <= requiredLength) return array;
  const gap = array.length / requiredLength;
  const indexes = Array.from({ length: requiredLength - 1 }, (_, i) => Math.round(i * gap));
  return array.filter((_, i) => indexes.includes(i) || i === array.length - 1);
};

/**
 * like lodash/set, but reverse functional.
 * ex: { c: 2, a: { b: 1, x: 9 }} --> { c: 2, 'a.b': 1, 'a.x': 9 }
 * @param {Object} object
 * @param {String} divider, default '.'
 * @return {Object} newObject
 */
export const flattenObject = (object, divider = '.') => Object.fromEntries(
  Object.entries(object).map(([key, value]) => {
    if (isObjectLike(value) && !Array.isArray(value)) {
      return Object.entries(
        flattenObject(value, divider),
      ).map(([newKey, newValue]) => [`${key}${divider}${newKey}`, newValue]);
    }
    return [[key, value]];
  }).flat(),
);

export const corvertQuery = (params) => {
  const query = Object.entries(params || {}).filter(([key, value]) => key && value).map(([key, value]) => [key, value].join('=')).join('&');
  return query ? `?${query}` : '';
};

export const printContent = (content, style = '') => {
  const w = window.open();
  const html = `<!DOCTYPE HTML>
    <html lang="en-us">
    <head>
      <title>Печатная страница</title>
      <style>${style}</style>
    </head>
    <body>
    ${content}
    </body>
  `;
  w.document.write(html);
  w.window.print();
  w.document.close();
};
